export default "__VITE_ASSET__DV_hn1Mo__"